export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">联系我们</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">
            欢迎投稿、合作或反馈意见，我们期待你的声音
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {/* 投稿 */}
          <div className="bg-background-50 border border-background-300/30 rounded-xl p-6 text-center transition-all hover:border-primary-500/20 cursor-pointer">
            <div className="w-12 h-12 rounded-full bg-primary-500/10 flex items-center justify-center mx-auto mb-4">
              <i className="ri-send-plane-line text-xl text-primary-400"></i>
            </div>
            <h3 className="text-sm font-heading font-bold text-foreground-900">内容投稿</h3>
            <p className="mt-2 text-xs text-foreground-600 leading-relaxed">
              有精彩内容想要分享？欢迎向我们投稿，优质内容将获得首页推荐曝光。
            </p>
            <a
              href="mailto:tougao@heiliao.example.com"
              className="inline-block mt-4 text-xs font-medium text-primary-400 hover:text-primary-300 transition-colors whitespace-nowrap"
            >
              tougao@heiliao.example.com
            </a>
          </div>

          {/* 商务合作 */}
          <div className="bg-background-50 border border-background-300/30 rounded-xl p-6 text-center transition-all hover:border-accent-500/20 cursor-pointer">
            <div className="w-12 h-12 rounded-full bg-accent-500/10 flex items-center justify-center mx-auto mb-4">
              <i className="ri-briefcase-line text-xl text-accent-400"></i>
            </div>
            <h3 className="text-sm font-heading font-bold text-foreground-900">商务合作</h3>
            <p className="mt-2 text-xs text-foreground-600 leading-relaxed">
              广告投放、品牌合作、内容联运等商务需求，欢迎来聊。
            </p>
            <a
              href="mailto:business@heiliao.example.com"
              className="inline-block mt-4 text-xs font-medium text-accent-400 hover:text-accent-300 transition-colors whitespace-nowrap"
            >
              business@heiliao.example.com
            </a>
          </div>

          {/* 意见反馈 */}
          <div className="bg-background-50 border border-background-300/30 rounded-xl p-6 text-center transition-all hover:border-primary-500/20 cursor-pointer">
            <div className="w-12 h-12 rounded-full bg-primary-500/10 flex items-center justify-center mx-auto mb-4">
              <i className="ri-feedback-line text-xl text-primary-400"></i>
            </div>
            <h3 className="text-sm font-heading font-bold text-foreground-900">意见反馈</h3>
            <p className="mt-2 text-xs text-foreground-600 leading-relaxed">
              使用过程中有任何问题或建议，请随时告诉我们，我们会尽快改进。
            </p>
            <a
              href="mailto:feedback@heiliao.example.com"
              className="inline-block mt-4 text-xs font-medium text-primary-400 hover:text-primary-300 transition-colors whitespace-nowrap"
            >
              feedback@heiliao.example.com
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}